import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuillModule } from 'ngx-quill';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { SearchComponent } from './search/search.component';
import {
  P500UIButtonsModule,
  P500UIDropdownModule,
  P500UIFormFieldsModule,
  P500UIIconsModule,
  P500UIPipesModule,
  P500UIProgressModule,
  P500UITooltipModule,
} from '@platform500services/p500-ui-kit';
import { QuestionsComponent } from './questions/questions.component';
import { PqlEditorDynamicComponent } from './pql-editor-dynamic/pql-editor-dynamic.component';
import { MentionModule } from 'angular-mentions';
import { PqlEditorComponent } from './pql-editor/pql-editor.component';
import { OfferUrlParamsAffiliateComponent } from './offer-url-params-affiliate/offer-url-params-affiliate.component';
import { OfferUrlParamsComponent } from './offer-url-params/offer-url-params.component';
import { IndeterminateCheckboxComponent } from './indeterminate-checkbox/indeterminate-checkbox.component';
import { ImageUploaderComponent } from './image-uploader/image-uploader.component';
import { ChartComponent } from './crm-settings/chart/chart.component';
import { CrmQuestionsFieldComponent } from './crm-questions/crm-questions.component';
import { BaselineCumulativeComponent } from './baseline-cumulative/baseline-cumulative.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RbacDirectiveModule } from '../../directives/rbac/rbac-directive.module';
import { AffiliateAccessComponent } from './affiliate-access/affiliate-access.component';
import { OfferAccessComponent } from './offer-access/offer-access.component';
import { EmptyModule } from '../empty/empty.module';
import { AdvertiserConditionsComponent } from './advertiser-conditions/advertiser-conditions.component';
import { FieldsModule } from '../fields/fields.module';
import { LayoutModule } from '@angular/cdk/layout';
import { DragDropSelectComponent } from './drag-drop-select/drag-drop-select.component';
import { ListSettingsComponent } from './list-settings/list-settings.component';
import { AffiliateLoginSettingsComponent } from './affiliate-login-settings/affiliate-login-settings.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { FinanceFieldComponent } from './finance/finance-field.component';
import { PaymentAccountComponent } from './payment-account/payment-account.component';
import { PaymentSystemFieldComponent } from './payment-system-field/payment-system-field.component';
import { CurrencyFieldComponent } from './currnecy-field/currency-field.component';
import { PaymentFieldsComponent } from './payment-fields/payment-fields.component';
import { PaymentSystemModule } from './payment-system/payment-system.module';
import { SelectWithHintComponent } from './controls-with-hint/select/select-with-hint.component';
import { SlideToggleWithHintComponent } from './controls-with-hint/slide-toggle/slide-toggle-with-hint.component';
import { TextWithHintComponent } from './controls-with-hint/text/text-with-hint.component';
import { HintDynamicModule } from '../help-information/hint-dynamic/hint-dynamic.module';
import { CurrencyFieldModule } from '../currnecy-field/currency-field.module';
import { ImageWithHintUploaderComponent } from './controls-with-hint/image-uploader/offer-wizard-image-uploader/image-with-hint-uploader.component';
import { ReferralProgramConditionsComponent } from './referral-program-conditions/referral-program-conditions.component';
import { RadioGroupWithHintComponent } from './controls-with-hint/radio-group/radio-group-with-hint.component';
import { ProtectedFormComponent } from './protected-form/protected-form.component';
import { MultipleTextComponent } from './multiple-text/multiple-text.component';
import { SelectWithIconWithHintComponent } from './controls-with-hint/select-with-icon-with-hint/select-with-icon-with-hint.component';
import { BooleanSelectWithHintComponent } from './controls-with-hint/boolean-select/boolean-select-with-hint.component';
import { CheckboxWithHintComponent } from './controls-with-hint/checkbox/checkbox-with-hint.component';
import { GroupCheckboxComponent } from './group-checkbox/group-checkbox.component';
import { RatingComponent } from './rating/rating.component';
import { TextWithPlaceholdersComponent } from './text-with-placeholders/text-with-placeholders.component';
import { CustomParametersComponent } from './custom-parameters/custom-parameters.component';
import { CheckboxWithLabelComponent } from './checkbox-with-label/checkbox-with-label.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    QuillModule.forRoot({
      format: 'html',
      theme: 'snow',
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ header: 1 }, { header: 2 }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ indent: '-1' }, { indent: '+1' }],
          [{ size: ['small', false, 'large', 'huge'] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          [{ font: [] }],
          [{ align: [] }],
          ['link', 'video'],
        ],
      },
      placeholder: 'Enter text...',
    }),
    P500UIIconsModule,
    P500UIFormFieldsModule,
    MentionModule,
    P500UITooltipModule,
    P500UIButtonsModule,
    P500UIDropdownModule,
    DragDropModule,
    RbacDirectiveModule,
    P500UIProgressModule,
    EmptyModule,
    FieldsModule,
    LayoutModule,
    CurrencyFieldModule,
    PaymentSystemModule,
    HintDynamicModule,
    P500UIPipesModule,
  ],
  declarations: [
    TextEditorComponent,
    SearchComponent,
    QuestionsComponent,
    PqlEditorDynamicComponent,
    PqlEditorComponent,
    OfferUrlParamsAffiliateComponent,
    OfferUrlParamsComponent,
    IndeterminateCheckboxComponent,
    ImageUploaderComponent,
    ChartComponent,
    CrmQuestionsFieldComponent,
    BaselineCumulativeComponent,
    AffiliateAccessComponent,
    OfferAccessComponent,
    AdvertiserConditionsComponent,
    DragDropSelectComponent,
    ListSettingsComponent,
    AffiliateLoginSettingsComponent,
    FileUploaderComponent,
    FinanceFieldComponent,
    PaymentAccountComponent,
    PaymentSystemFieldComponent,
    CurrencyFieldComponent,
    PaymentFieldsComponent,
    PaymentAccountComponent,
    PaymentSystemFieldComponent,
    CurrencyFieldComponent,
    PaymentFieldsComponent,
    ImageWithHintUploaderComponent,
    SelectWithHintComponent,
    BooleanSelectWithHintComponent,
    SlideToggleWithHintComponent,
    TextWithHintComponent,
    CheckboxWithHintComponent,
    RadioGroupWithHintComponent,
    ReferralProgramConditionsComponent,
    ProtectedFormComponent,
    MultipleTextComponent,
    SelectWithIconWithHintComponent,
    GroupCheckboxComponent,
    RatingComponent,
    TextWithPlaceholdersComponent,
    CustomParametersComponent,
    CheckboxWithLabelComponent,
  ],
  exports: [
    TextEditorComponent,
    SearchComponent,
    QuestionsComponent,
    PqlEditorDynamicComponent,
    PqlEditorComponent,
    OfferUrlParamsAffiliateComponent,
    OfferUrlParamsComponent,
    IndeterminateCheckboxComponent,
    ImageUploaderComponent,
    ChartComponent,
    CrmQuestionsFieldComponent,
    BaselineCumulativeComponent,
    AffiliateAccessComponent,
    OfferAccessComponent,
    AdvertiserConditionsComponent,
    DragDropSelectComponent,
    ListSettingsComponent,
    AffiliateLoginSettingsComponent,
    FileUploaderComponent,
    FinanceFieldComponent,
    CurrencyFieldModule,
    SelectWithHintComponent,
    BooleanSelectWithHintComponent,
    SlideToggleWithHintComponent,
    TextWithHintComponent,
    CheckboxWithHintComponent,
    RadioGroupWithHintComponent,
    MultipleTextComponent,
    SelectWithIconWithHintComponent,
    GroupCheckboxComponent,
    RatingComponent,
    ImageWithHintUploaderComponent,
    TextWithPlaceholdersComponent,
    CustomParametersComponent,
    CheckboxWithLabelComponent,
  ],
})
export class FormFieldsModule {}
